import React, { useState } from "react";
import api, { errText } from "@/lib/api";
import { toast } from "sonner";
import { HeartHandshake } from "lucide-react";

export default function Referral() {
  const [f, setF] = useState({ customer_name: "", friend_name: "", friend_phone: "", friend_email: "" });
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async () => {
    try { await api.post("/referrals", f); setSent(true); toast.success("Referral submitted!"); }
    catch (e) { toast.error(errText(e.response?.data?.detail)); }
  };
  const input = "w-full h-12 px-4 rounded-sm border border-slate-300 focus:outline-none focus:ring-2 focus:ring-[#C5A059]";

  return (
    <div className="max-w-xl mx-auto px-5 py-16">
      <HeartHandshake className="text-[#C5A059] mb-4" size={40} />
      <h1 className="font-display text-4xl font-black leading-tight">LOVE YOUR COVERAGE?<br />REFER A FRIEND.</h1>
      <p className="mt-3 text-slate-600">Know someone who could use a better rate? Send them our way.</p>
      {sent ? (
        <div className="mt-8 bg-white border border-slate-200 rounded-sm p-8 text-center" data-testid="referral-success">
          <p className="font-display text-2xl font-bold">Thank you!</p>
          <p className="text-slate-600 mt-2">We'll reach out to your friend shortly.</p>
        </div>
      ) : (
        <div className="mt-8 bg-white border border-slate-200 rounded-sm p-6 space-y-4">
          <input className={input} placeholder="Your Name" value={f.customer_name} onChange={set("customer_name")} data-testid="ref-customer-name" />
          <input className={input} placeholder="Friend's Name" value={f.friend_name} onChange={set("friend_name")} data-testid="ref-friend-name" />
          <input className={input} placeholder="Friend's Phone" value={f.friend_phone} onChange={set("friend_phone")} data-testid="ref-friend-phone" />
          <input className={input} placeholder="Friend's Email" value={f.friend_email} onChange={set("friend_email")} data-testid="ref-friend-email" />
          <button onClick={submit} className="w-full bg-[#C5A059] text-[#0B1E36] font-bold h-13 py-4 rounded-sm hover:bg-[#0B1E36] hover:text-white transition-colors" data-testid="ref-submit">SEND REFERRAL</button>
          <p className="text-xs text-slate-500">By submitting, you confirm your friend agrees to be contacted about insurance options.</p>
        </div>
      )}
    </div>
  );
}
